type ItemNameType =
  | 'consumer_loan'
  | 'home_loan'
  | 'education_loan'
  | 'refinancing'
  | 'car_loan'
  | 'travel_loan'
  | 'business_loan'
  | 'health_loan'
  | 'item_not_specified';

type EventNameType =
  | 'view_item'
  | 'choose_loan'
  | 'create_account'
  | 'personal_info'
  | 'emta_consent'
  | 'cashflow'
  | 'additional_info'
  | 'accountscroing_consent'
  | 'thank-you'
  | 'proposal_sent'
  | 'contract_signed';

type ContentStepType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

type EventContentStepType = {
  event: EventNameType;
  content_step: ContentStepType;
};

interface TagAssistantEvent {
  event: EventNameType;
  content_step: ContentStepType;
  value?: number;
  currency?: string;
  transaction_id?: string;
  item_name: ItemNameType;
}

export const trackGTM = (eventData: TagAssistantEvent): void => {
    window.dataLayer = window.dataLayer || [];

    const isEventAlreadyPushed = window.dataLayer.some((data: TagAssistantEvent) => data.event === eventData.event);

    if (!isEventAlreadyPushed) {
      window.dataLayer.push(eventData);
    }
};

export const convertToDataLayerName = (legacyName: string | null): ItemNameType => {
  if (legacyName === null) {
    return 'item_not_specified';
  }

  const conversions: { [key: string]: ItemNameType } = {
    'consumer': 'consumer_loan',
    'home': 'home_loan',
    'travel': 'travel_loan',
    'refinancing': 'refinancing',
    'mz_refinancing': 'refinancing',
    'pre_refinancing': 'refinancing',
    'vehicle': 'car_loan',
    'health': 'health_loan',
    'business': 'business_loan',
    'education': 'education_loan',
  };

  const result = conversions[legacyName];

  if (!result) {
    throw new Error(`Unrecognized legacyName: ${legacyName}`);
  }

  return result;
};

export const generateDataLayerEventObject = (eventName: EventNameType): EventContentStepType => {
  const conversions: { [key: string]: EventContentStepType } = {
    'choose_loan': { event: 'choose_loan', content_step: 1 },
    'create_account': { event: 'create_account', content_step: 2 },
    'personal_info': { event: 'personal_info', content_step: 3 },
    'cashflow': { event: 'cashflow', content_step: 5 },
    'additional_info': { event: 'additional_info', content_step: 6 },
    'proposal_sent': { event: 'proposal_sent', content_step: 9 },
    'contract_signed': { event: 'contract_signed', content_step: 10 },
  };

  const result = conversions[eventName];

  if (!result) {
    throw new Error(`Unrecognized event name: ${eventName}`);
  }

  return result;
};
